export default __webpack_public_path__ + "static/media/why-readpro.5263e2bc.gif";